import api from './api';

const externalApiService = {
  async listIntegrations() {
    return api.get('/api/external-api/integrations');
  },

  async createIntegration(payload) {
    return api.post('/api/external-api/integrations', payload);
  },

  async updateIntegration(id, payload) {
    return api.request(`/api/external-api/integrations/${id}`, { method: 'PATCH', body: payload });
  },

  async regenerateToken(id) {
    return api.post(`/api/external-api/integrations/${id}/regenerate-token`, {});
  },

  async listMessageTemplates(params = {}) {
    const qs = new URLSearchParams();
    if (params.status) qs.set('status', String(params.status));
    if (params.serviceChannel) qs.set('serviceChannel', String(params.serviceChannel));
    if (params.messageCategory) qs.set('messageCategory', String(params.messageCategory));
    const endpoint = `/api/external-api/message-templates${qs.toString() ? `?${qs.toString()}` : ''}`;
    return api.get(endpoint);
  },

  async createMessageTemplate(payload) {
    return api.post('/api/external-api/message-templates', payload);
  },

  async updateMessageTemplate(id, payload) {
    return api.request(`/api/external-api/message-templates/${id}`, { method: 'PATCH', body: payload });
  },

  async listMessages(params = {}) {
    const qs = new URLSearchParams();
    qs.set('all', '1');
    if (params.page) qs.set('page', String(params.page));
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.status) qs.set('status', String(params.status));
    if (params.integrationId) qs.set('integrationId', String(params.integrationId));
    if (params.serviceChannel) qs.set('serviceChannel', String(params.serviceChannel));
    if (params.messageCategory) qs.set('messageCategory', String(params.messageCategory));
    if (params.messageTemplateId) qs.set('messageTemplateId', String(params.messageTemplateId));
    if (params.number) qs.set('number', String(params.number));
    if (params.start) qs.set('start', String(params.start));
    if (params.end) qs.set('end', String(params.end));
    const endpoint = `/api/external-api/messages${qs.toString() ? `?${qs.toString()}` : ''}`;
    return api.get(endpoint);
  },

  async getMessage(id) {
    return api.get(`/api/external-api/messages/${id}?all=1`);
  },

  async reprocessMessage(id) {
    return api.post(`/api/external-api/messages/${id}/reprocess`, {});
  },

  async listWebhooks(params = {}) {
    const qs = new URLSearchParams();
    if (params.integrationId) qs.set('integrationId', String(params.integrationId));
    const endpoint = `/api/external-api/webhooks${qs.toString() ? `?${qs.toString()}` : ''}`;
    return api.get(endpoint);
  },

  async createWebhook(payload) {
    return api.post('/api/external-api/webhooks', payload);
  },

  async updateWebhook(id, payload) {
    return api.request(`/api/external-api/webhooks/${id}`, { method: 'PATCH', body: payload });
  },

  async regenerateWebhookSecret(id) {
    return api.post(`/api/external-api/webhooks/${id}/regenerate-secret`, {});
  },

  async listWebhookDeliveries(params = {}) {
    const qs = new URLSearchParams();
    if (params.integrationId) qs.set('integrationId', String(params.integrationId));
    if (params.webhookId) qs.set('webhookId', String(params.webhookId));
    if (params.requestId) qs.set('requestId', String(params.requestId));
    if (params.limit) qs.set('limit', String(params.limit));
    const endpoint = `/api/external-api/webhook-deliveries${qs.toString() ? `?${qs.toString()}` : ''}`;
    return api.get(endpoint);
  },

  async getQueueStats() {
    return api.get('/api/external-api/queue/stats');
  },

  async listDeadletters(params = {}) {
    const qs = new URLSearchParams();
    if (params.page) qs.set('page', String(params.page));
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.integrationId) qs.set('integrationId', String(params.integrationId));
    if (params.queueName) qs.set('queueName', String(params.queueName));
    if (params.jobName) qs.set('jobName', String(params.jobName));
    if (params.requestUuid) qs.set('requestUuid', String(params.requestUuid));
    if (params.requestId) qs.set('requestId', String(params.requestId));
    const endpoint = `/api/external-api/deadletters${qs.toString() ? `?${qs.toString()}` : ''}`;
    return api.get(endpoint);
  },

  async reprocessDeadletter(id) {
    return api.post(`/api/external-api/deadletters/${id}/reprocess`, {});
  }
};

export default externalApiService;
